export default __webpack_public_path__ + "static/media/2.0c322dac.png";